__turbopack_context__.v({
  "content": "mS2eJW_content",
  "content-container": "mS2eJW_content-container",
  "controls": "mS2eJW_controls",
  "controls-container": "mS2eJW_controls-container",
  "controls-content": "mS2eJW_controls-content",
  "energy-type-button": "mS2eJW_energy-type-button",
  "energy-type-filter": "mS2eJW_energy-type-filter",
  "fixed": "mS2eJW_fixed",
  "map": "mS2eJW_map",
  "map-container": "mS2eJW_map-container",
  "mobile-map-view": "mS2eJW_mobile-map-view",
  "producer-info-sidebar-mobile": "mS2eJW_producer-info-sidebar-mobile",
  "producers": "mS2eJW_producers",
  "producers-container": "mS2eJW_producers-container",
  "producers-content": "mS2eJW_producers-content",
  "producers-overview": "mS2eJW_producers-overview",
  "view-toggle": "mS2eJW_view-toggle",
});
